import {
  cibFacebook,
  cilSync,
  cilMenu,
  cilCloudUpload,
  cilInfo,
  cilWarning,
  cibLine,
  cibGmail,
  cibTwitter,
  cibLinkedin,
  cibFlickr,
  cibTumblr,
  cibXing,
  cibGithub,
  cibStackOverflow,
  cibYoutube,
  cibDribbble,
  cibInstagram,
  cibPinterest,
  cibVk,
  cibYahoo,
  cibBehance,
  cibReddit,
  cibVimeo,
  cibCcMastercard,
  cibCcVisa,
  cibStripe,
  cibPaypal,
  cibGooglePay,
  cibCcAmex,
  cibGoogle,
  cibFacebookF,
  cifUs,
  cifBr,
  cifIn,
  cifFr,
  cifEs,
  cifPl,
  cifTh,
  cilHome,
  cilBook,
  cilBirthdayCake,
  cilArrowRight,
  cilArrowLeft,
  cilBurger,
  cilInput,
  cilCart,
  cilActionRedo,
  cilPhone,
  cilSitemap,
  cilWallet,
  cilCreditCard,
  cilGift,
  cilBan,
  cilBasket,
  cilBell,
  cilCalculator,
  cilCalendar,
  cilCloudDownload,
  cilChartPie,
  cilCheck,
  cilQrCode,
  cilChevronBottom,
  cilChevronTop,
  cilCheckCircle,
  cilCommentSquare,
  cilCursor,
  cilDrop,
  cilDollar,
  cilEnvelopeClosed,
  cilEnvelopeOpen,
  cilEuro,
  cilGlobeAlt,
  cilGrid,
  cilFile,
  cilJustifyCenter,
  cilLaptop,
  cilLayers,
  cilLightbulb,
  cilList,
  cilLocationPin,
  cilLockLocked,
  cilMagnifyingGlass,
  cilMoon,
  cilOptions,
  cilPencil,
  cilPeople,
  cilPuzzle,
  cilSettings,
  cilShieldAlt,
  cilSpeech,
  cilSpeedometer,
  cilStar,
  cilTask,
  cilUser,
  cilUserFemale,
  cilUserFollow,
  cilBarChart,
  cilX,
  cilXCircle,
  cilApplications,
  cilChevronLeft,
  cilAccountLogout,
  cilFastfood,
  cilFolderOpen,
  cilChart,
  cilChartLine,
  cilMoney,
  cilTag,
  cilSmilePlus,
  cilArrowThickFromRight,
  cilHistory,
  cilTrash,
  cilCircle,
  cilTruck,
  cilMap,
} from '@coreui/icons'

export const iconsSet = Object.assign(
  {},
  {
    cilHome,
    cilBook,
    cilBirthdayCake,
    cilTrash,
    cilHistory,
    cilArrowThickFromRight,
    cilArrowRight,
    cilArrowLeft,
    cilBan,
    cilBasket,
    cilBell,
    cilBarChart,
    cilCalculator,
    cilCalendar,
    cilCloudDownload,
    cilChartPie,
    cilCheck,
    cilQrCode,
    cilChevronBottom,
    cilChevronTop,
    cilCheckCircle,
    cilCommentSquare,
    cilCursor,
    cilDrop,
    cilDollar,
    cilEnvelopeClosed,
    cilEnvelopeOpen,
    cilEuro,
    cilGlobeAlt,
    cilGrid,
    cilFile,
    cilJustifyCenter,
    cilLaptop,
    cilLayers,
    cilLightbulb,
    cilList,
    cilLocationPin,
    cilLockLocked,
    cilMagnifyingGlass,
    cilMoon,
    cilOptions,
    cilPencil,
    cilPeople,
    cilPuzzle,
    cilSettings,
    cilShieldAlt,
    cilSpeech,
    cilSpeedometer,
    cilStar,
    cilTask,
    cilUser,
    cilUserFemale,
    cilUserFollow,
    cilX,
    cilXCircle,
    cilApplications,
    cilChevronLeft,
    cilCircle,
    cilTruck,
    cilMap,
  },
  {
    cifUs,
    cifTh,
    cifBr,
    cifIn,
    cifFr,
    cifEs,
    cifPl,
  },
  {
    cibFacebook,
    cilSync,
    cilMenu,
    cilCloudUpload,
    cilInfo,
    cilWarning,
    cibLine,
    cibGmail,
    cibTwitter,
    cibLinkedin,
    cibFlickr,
    cibTumblr,
    cibXing,
    cibGithub,
    cibStackOverflow,
    cibYoutube,
    cibDribbble,
    cibInstagram,
    cibPinterest,
    cibVk,
    cibYahoo,
    cibBehance,
    cibReddit,
    cibVimeo,
    cibCcMastercard,
    cibCcVisa,
    cibStripe,
    cibPaypal,
    cibGooglePay,
    cibCcAmex,
    cilAccountLogout,
    cilFastfood,
    cilFolderOpen,
    cilChart,
    cilChartLine,
    cilMoney,
    cilTag,
    cilSmilePlus,
    cibGoogle,
    cibFacebookF,
    cilBurger,
    cilInput,
    cilCart,
    cilActionRedo,
    cilPhone,
    cilCreditCard,
    cilSitemap,
    cilWallet,
    cilGift,
  }
)
